import React from "react";

import { Compass, CheckCircle, TrendingUp } from "lucide-react";

import { ExperimentType, experimentTypes } from "./researchFoundation.constants";

interface ExperimentTypeSelectorCardsProps {
  value: ExperimentType;
  onChange: (value: ExperimentType) => void;
}

const iconMap = {
  Compass,
  CheckCircle,
  TrendingUp,
};

export const ExperimentTypeSelectorCards: React.FC<
  ExperimentTypeSelectorCardsProps
> = ({ value, onChange }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {experimentTypes.map((type) => {
        const Icon = iconMap[type.icon as keyof typeof iconMap];
        const isSelected = value === type.id;

        return (
          <button
            key={type.id}
            onClick={() => onChange(type.id)}
            className={`group relative rounded-xl border bg-white/5 p-4 text-left transition-all duration-300 hover:border-blue-400/50 hover:bg-white/10 ${
              isSelected
                ? "border-amber-400 bg-amber-400/10 shadow-lg shadow-amber-400/10"
                : "border-white/20"
            }`}
          >
            {isSelected && (
              <div className="absolute right-2 top-2 h-2 w-2 animate-pulse rounded-full bg-amber-300" />
            )}

            <div className="space-y-2">
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-lg transition-colors duration-300 ${
                  isSelected
                    ? "bg-amber-400/20"
                    : "bg-blue-500/20 group-hover:bg-blue-500/30"
                }`}
              >
                <Icon
                  size={20}
                  className={isSelected ? "text-amber-300" : "text-blue-400"}
                />
              </div>

              <div>
                <h4
                  className={`text-sm font-semibold ${isSelected ? "text-amber-300" : "text-white"}`}
                >
                  {type.label}
                </h4>
                <p className="mt-1 text-xs leading-relaxed text-white/60">
                  {type.description}
                </p>
              </div>

              <p className="text-[10px] uppercase tracking-wide text-white/40">
                {type.whenToUse}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
};
